module.exports = __webpack_public_path__ + "img/share-icon.98dbf59f.svg";